import React, { useState, useRef, useEffect } from 'react';
import './tabs.css';

import iconCamera from '../../assets/img/tab/camera.png';
import iconCinematography from '../../assets/img/tab/cinematography.png';

import cinematicPhoto1 from '../../assets/img/tab/wedding-1.jpg';
import cinematicPhoto2 from '../../assets/img/tab/wedding-2.jpg';
import cinematicPhoto3 from '../../assets/img/tab/wedding-3.jpg';
import cinematicPhoto4 from '../../assets/img/tab/wedding-4.jpg';
import cinematicPhoto5 from '../../assets/img/tab/wedding-5.jpg';
import cinematicPhoto6 from '../../assets/img/tab/wedding-6.jpg';
import cinematicPhoto7 from '../../assets/img/tab/wedding-7.jpg';
import cinematicPhoto8 from '../../assets/img/tab/wedding-8.jpg';

import weddingPhoto1 from '../../assets/img/tab/cinematic-8.jpg';
import weddingPhoto2 from '../../assets/img/tab/cinematic-2.jpeg';
import weddingPhoto3 from '../../assets/img/tab/cinematic-3.jpeg';
import weddingPhoto4 from '../../assets/img/tab/cinematic-4.jpeg';
import weddingPhoto5 from '../../assets/img/tab/cinematic-5.jpeg';
import weddingPhoto6 from '../../assets/img/tab/cinematic-6.jpg';
import weddingPhoto7 from '../../assets/img/tab/cinematic-7.jpg';
import weddingPhoto8 from '../../assets/img/tab/cinematic-8.jpg';

const Tabs = () => {
    const [activeTab, setActiveTab] = useState(0);
    const contentRef = useRef(null);

    const tabContent = [
      {
        title: "Wedding Photography",
        icon: iconCamera,
        content: [
          cinematicPhoto1,
          cinematicPhoto2,
          cinematicPhoto3,
          cinematicPhoto4,
          cinematicPhoto5,
          cinematicPhoto6,
          cinematicPhoto7,
          cinematicPhoto8,
        ],
      },
      {
        title: "Cinematic Photography",
        icon: iconCinematography,
        content: [
          weddingPhoto1,
          weddingPhoto2,
          weddingPhoto3,
          weddingPhoto4,
          weddingPhoto5,
          weddingPhoto6,
          weddingPhoto7,
          weddingPhoto8,
        ],
      },
    ];

    useEffect(() => {
      // Preload images into browser cache
      const preloadMedia = () => {
        const mediaToPreload = tabContent.flatMap(tab => tab.content);
        mediaToPreload.forEach(src => {
          const image = new Image();
          image.src = src;
        });
      };

      preloadMedia();
    }, [tabContent]);

    const handleTabClick = (index) => {
      setActiveTab(index);
      if (window.innerWidth <= 768 && contentRef.current) {
        contentRef.current.scrollIntoView({ behavior: "smooth" });
      }
    };

    return (
      <div>
        <div className="tabs-container">
          <div className="tabs">
            {tabContent.map((tab, index) => (
              <div
                key={index}
                className={`tab ${index === activeTab ? 'active' : ''}`}
                onClick={() => handleTabClick(index)}
              >
                <div className="tab-content-1">
                  <img src={tab.icon} alt={tab.title} className="tab-icon" />
                  <span className="tab-title">{tab.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="main-content" ref={contentRef}>
          <div className="tab-content">
            {activeTab !== null && (
              <div className="content-grid">
                {tabContent[activeTab].content.map((imageSrc, index) => (
                  <div key={index} className="content-item">
                    <img src={imageSrc} alt={`Image ${index + 1}`} className="tab-image" />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
};

export default Tabs;